<template>
  <v-app style="height:100%;">
      <div class="mt-8">
        <div class="text-h6 mt-8"><b>การเข้ารับบริการตามนัดหมาย</b></div>
        <div class="text-h7 mt-4 ml-4" align="left">1. เลือก "คิวอาร์โค้ด" หรือ เครื่องหมาย [-] เพื่อเปิดกล้อง</div>
        <v-card class="d-inline-flex ma-2 pa-2">
          <v-img :src="activate_guide_1" style="width:30%;border: solid;border-width: thin;" contain />
          <div class="text-h8 align-self-center">หรือ</div>
          <v-img :src="activate_guide_2" style="width:30%;border: solid;border-width: thin;" contain />
        </v-card>
        <div class="text-h7 mt-2 ml-4" align="left">2. สแกนคิวอาร์โค้ดที่จุดบริการ แล้วทำการเปิดลิงค์</div>
          <v-img :src="activate_guide_3" style="width:45%;border: solid;border-width: thin;" contain class="ma-auto" />
         <a href="https://line.me/R/nv/addFriends" >
                <div style="background-color: darkblue; align-items: center; color: white;border-radius: 8px;" class="mr-8 ml-8 mt-6 mb-2">
                    <div>ฉันเข้าใจ</div>
                    <div>และมาถึงจุดสแกนแล้ว</div>
                    <div>ตามนัดแล้ว</div>
                </div>
            </a>
      <v-btn outlined style="color:black" rounded color="grey" @click="close">
      <v-icon left>mdi-close</v-icon>ปิด</v-btn>
      </div>
  </v-app>
</template>

<style>
html {
    height: 100%;
}
body {
    height: 100%;
}
#app {
    height: 100%;
}
</style>

<script>

import App from '@/models/instance/App'

export default {
  data () {
        return {
            activate_guide_1: require('@/assets/activate_guide_1.jpg')
            ,activate_guide_2: require('@/assets/activate_guide_2.jpg')
            ,activate_guide_3: require('@/assets/activate_guide_3.jpg')
        }
  },
  methods : {
    close(){
      window.location.href = App.getAppConfigAddFriendUrl()
    }
  }
}

</script>